import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  CircularProgress, 
  Typography, 
  Box, 
  Paper,
  Container,
  Fade,
  Avatar
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../Context/AuthContext';

const LogoutPage = () => {
  const navigate = useNavigate();
  const { setAuth } = useAuth();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Update countdown every second
    const countdownInterval = setInterval(() => {
      setCountdown((prevCount) => Math.max(0, prevCount - 1));
    }, 1000);

    // Logout and redirect after 5 seconds
    const logoutTimer = setTimeout(() => {
      try {
        localStorage.removeItem('autoChef_authToken');
        setAuth(false);
        navigate('/login');
      } catch (error) {
        console.error('Error during logout:', error);
        navigate('/login'); // Redirect anyway in case of error
      }
    }, 5000);

    // Cleanup function
    return () => {
      clearInterval(countdownInterval);
      clearTimeout(logoutTimer);
    };
  }, [navigate, setAuth]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Fade in={true} timeout={800}>
        <Container maxWidth="sm">
          <Paper
            elevation={3}
            sx={{
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              borderRadius: 2,
            }}
          >
            <Avatar
              sx={{
                bgcolor: 'primary.main',
                width: 56,
                height: 56,
                mb: 2,
              }}
            >
              <LogoutIcon fontSize="large" />
            </Avatar>
            
            <Typography variant="h5" fontWeight="500" gutterBottom>
              Logging Out
            </Typography>
            
            <Box sx={{ display: 'flex', alignItems: 'center', my: 2 }}>
              <CircularProgress size={24} sx={{ mr: 1 }} />
              <Typography>
                Please wait while we log you out...
              </Typography>
            </Box>
            
            <Typography color="text.secondary" fontSize="0.875rem" mt={2}>
              Redirecting to login page in {countdown} second{countdown !== 1 ? 's' : ''}
            </Typography>
          </Paper>
        </Container>
      </Fade>
    </Box>
  );
};

export default LogoutPage;
